module.exports = __webpack_public_path__ + "img/ep-soleil2.31d2954e.jpg";